import { Navigate, useSearchParams } from "react-router-dom";
import { getInvestorQueryParams, withInvestorQuery } from "../../../utils/investorRouteHelpers";

/** Legacy route — KYC lives under Profile → Identity verification. */
export default function InvestorKycPage() {
  const [searchParams] = useSearchParams();
  const query = getInvestorQueryParams(searchParams);

  return (
    <Navigate
      to={withInvestorQuery("/invest/profile", { ...query, tab: "verification" })}
      replace
    />
  );
}
